/**
 * Pin-to-viewport texture overlay. The actual page backdrop (radial
 * spotlight + tech grid) lives on `body` via `var(--page-bg)` because
 * each panel's `.lg-mirror` needs to paint the same gradient stack
 * with `background-attachment: fixed` to stay aligned. This component
 * adds a subtle grain layer on top, which doesn't need to be inside
 * the panel mirrors.
 */
export function BackgroundField() {
  return (
    <div className="bg-field" aria-hidden="true">
      <div className="bg-field__grain" />
    </div>
  );
}
